export function transToastType(type) {
  // 'normal' | 'highlight' | 'destructive' | 'warning' | 'standby' | 'info'
  if (type === 'destructive') {
    return 'error';
  }
  if (type === 'warning') {
    return 'warning';
  }
  if (type === 'standby' || type === 'highlight') {
    return 'success';
  }
  return 'info';
}

export function loginToast(toastOptions, ElMessage) {
  const { content: message = '未知错误', type, timeout: duration = 3000 } = toastOptions || {};
  ElMessage({
    message,
    duration,
    type: transToastType(type),
  });
}
